import styled from 'styled-components';

import colors from '../../theme/constants/colors';

export const TextMatch = styled.span`
  color: ${colors.dollar};
  font-weight: bold;
`;
